<template>
  <div>
    <b-modal id="modalEncerradas" data-backdrop="static" data-keyboard="false" size="xl" centered :title="$t('OS Encerradas - Últimas 15 OS')">
      <div style="overflow: auto; height: 510px;">

        <div class="col-sm-12 text-sm-right">
          <button style="margin-top: 0px!important" class="btn btn-info btn-sm-block mr-2" id="btnFiltro"
            v-b-toggle.collapse-filtrosEncerradas>
            <i class="fas fa-filter mr-2"></i>
          </button>
        </div>

        <b-collapse id="collapse-filtrosEncerradas">
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header">
                  {{ $t('Filtros') }}
                </div>
                <div class="card-body pt-2 pb-2">
                  <form action="" class="form">
                    <div class="row">
                      <div class="form-group col-md-2">
                        <label>{{ $t('Placa') }}</label>
                        <v-select :options="veiculos" @input="internalFilters.placa = $event.label" :placeholder="$t('Placa')">
                        </v-select>
                      </div>
                    </div>
                  </form>

                </div>
                <div class="card-footer text-right">
                  <button class="btn btn-info btn-sm-block float-sm-right" @click="applyFilters">
                    <i class="fas fa-filter"></i> {{ $t('Aplicar filtro') }}
                  </button>
                  <button class="btn btn-outline-dark mr-2 btn-sm-block" @click="setFilters">
                    <i class="fas fa-times"></i> {{ $t('Limpar filtros') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>

        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">{{ $t('NÚMERO') }}</th>
              <th scope="col">{{ $t('PLACA') }}</th>
              <th scope="col">{{ $t('DATA') }}</th>
              <th scope="col">{{ $t('INÍCIO') }}</th>
              <th scope="col">{{ $t('FINAL') }}</th>
              <th scope="col">{{ $t('SEGMENTO') }}</th>
              <th scope="col">{{ $t('PROBLEMA') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(ordemServico, index) in ordemServicos" :key="index">
              <td>{{ ordemServico.nr_sequencial }}</td>
              <td>{{ ordemServico.nr_placa }}</td>
              <td>{{ ordemServico.dt_os | formatDate("DD/MM/YYYY HH:mm") }}</td>
              <td>{{ ordemServico.dt_inicial | formatDate("DD/MM/YYYY HH:mm") }}</td>
              <td>{{ ordemServico.dt_final | formatDate("DD/MM/YYYY HH:mm") }}</td>
              <td>{{ ordemServico.ds_grupo }}</td>
              <td>{{ ordemServico.ds_conjunto }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <template #modal-footer>
        <div class="w-100">
          <div class="row center" style="justify-content: center; ">
            <b-button class="mr-2" variant="danger" size="lg" @click="$bvModal.hide('modalEncerradas')">
              {{ $t('Fechar') }}
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: 'ModalItems',
  data() {
    return {
      internalFilters: {},
      showFiltros: false,
    }
  },
  methods: {
    getOsEncerradas() {
      this.$store.dispatch('os/getOsEncerrada')
    },
    setFilters(){
      this.$store.dispatch('os/getOsEncerrada', {})
    },
    applyFilters() {
      // console.log(this.internalFilters)
      this.$store.dispatch('os/getOsEncerrada', { data: this.internalFilters })
    }
  },

  computed: {
    ordemServicos() {
      const ordemServico = this.$store.getters['os/getOsEncerradas']

      if (!ordemServico) {
        this.$store.dispatch('os/getOsEncerrada', {})

        return {}
      }

      return ordemServico
    },

    
    veiculos() {
            const items = this.$store.getters['veiculo/itemsTemp']

            if (!items) {
                this.$store.dispatch('veiculo/fetchFromApi')
                return []
            }

            return items.map(item => {
                return {
                    ...item,
                    label: item.nr_placa
                }
            })
        },
  },

  created() {
    this.$store.dispatch('os/getOsEncerrada', {})
  },
}
</script>
<style scoped>
#modalItems {
  pointer-events: none !important;
  height: 750px !important;
}

.close {
  display: none !important;
}

#modalEncerradas___BV_modal_body_ {
  overflow: auto !important;
}
</style>